import type { Credential, SocialLink } from './schema'

/**
 * Who the site is about. START HERE: every page, the sidebar, the SEO tags and the legal pages read
 * these values, so changing them here changes them everywhere.
 */
export const site = {
  name: 'Alexcel F. Ancaja',
  brand: 'Alexcel Ancaja',
  /** The brand name as the sidebar logo shows it: the second part takes the accent color. */
  brandParts: ['Alexcel', 'Ancaja'],
  /** The logo mark, one file per theme (`light` = for light backgrounds). The 96px copies are the
   *  sidebar header (shown at 32-36px); the full ones are the Work logo faces. */
  logo: {
    light: '/images/brand/mark.webp',
    dark: '/images/brand/mark-light.webp',
    headerLight: '/images/brand/mark-96.webp',
    headerDark: '/images/brand/mark-light-96.webp',
  },
  /** The live address, no trailing slash. Canonical URLs, the sitemap and the JSON-LD use it. */
  url: 'https://alexcel-automates-me.lovable.app',
  role: 'AI Automation Specialist',
  email: 'ancajaalexcel101@gmail.com',
  emailSubject: 'Project inquiry',
  replyPromise: 'Reply within one business day.',
  location: 'Quezon City, Philippines, GMT+8',
  /** Two-letter country code (ISO 3166) for the Person JSON-LD address. */
  countryCode: 'PH',
  /** Your clock, shown live at the top of the sidebar. */
  timeZone: 'Asia/Manila',
  timePlace: 'in Quezon City',
  avatar: { src: '/images/profile/avatar.webp', alt: 'Alexcel F. Ancaja', width: 400, height: 400 },
  /** The sidebar picture (112px, 44px on the rail). */
  avatarSmall: '/images/profile/avatar-224.webp',
} as const

/** Shown in About and the sidebar check. Delete the `image` to show it without a badge. */
export const certification: Credential = {
  title: 'Information Computer Technology',
  detail: 'STI College Dasmariñas · 2018–2020',
  issuer: 'STI College Dasmarinas',
}

/** Up to five fit the sidebar header. */
export const socials: SocialLink[] = []

/** Off-site links the pages point at. */
export const externalLinks = {
  company: 'https://alexcel-automates-me.lovable.app',
} as const

export function mailtoHref(): string {
  return `mailto:${site.email}?subject=${encodeURIComponent(site.emailSubject)}`
}
